import {getCities, getDepths, getLayers, getTowns} from "@ui/api/features"
import {LayerId} from "@ui/services/features"
import {ITrack, Track} from "./service/track"
import {IUser, User} from "./user"
import {IMap, Map} from "./map"
import {Debug, IDebug} from "./debug"
import {Dictionary, IDictionary} from "./dictionary"
import {ISettings, Settings} from "./settings"
import {IMovement, Movement} from "./movement"
import {IRoute, Route} from "./service/route"
import {IProfile, Profile} from "./service/profile"
import {IPoi, Poi} from "./service/poi"
import {ILayer, Layer} from "./service/layer"
import {Adapter, IAdapter} from "./service/adapter"
import {IFeaturesCollections, FeaturesCollections, Point} from "./features/"
import {IFeature} from "./features/feature"
import {Buoy} from "./features/buoy"
import {Beacon} from "./features/beacon"
import {Line} from "./features/line"
import {Polygon} from "./features/polygon"
import {Other} from "./features/other"
import {Poi as FeaturePoi} from "./features/poi"

export interface IRoot {
  debug: IDebug
  user: IUser
  profile: IProfile
  map: IMap
  track: ITrack
  movement: IMovement
  route: IRoute
  dictionary: IDictionary
  settings: ISettings
  features?: IFeaturesCollections
  adapter: IAdapter
  poi: IPoi
  layer: ILayer

  init(): Promise<void>
}

export class Root implements IRoot {
  debug: IDebug
  track: ITrack
  movement: IMovement
  user: IUser
  profile: IProfile
  map: IMap
  route: IRoute
  dictionary: IDictionary
  settings: ISettings
  features?: IFeaturesCollections
  adapter: IAdapter
  poi: IPoi
  layer: ILayer

  constructor() {
    this.debug = new Debug()
    this.user = new User()
    this.profile = new Profile()
    this.map = new Map()
    this.track = new Track()
    this.movement = new Movement()
    this.route = new Route()
    this.dictionary = new Dictionary()
    this.settings = new Settings()
    this.adapter = new Adapter()
    this.poi = new Poi()
    this.layer = new Layer()
  }

  async init() {
    await getLayers()
      .then(layers => {
        this.features = new FeaturesCollections(Object.entries(layers)
          .flatMap(([name, {seconds, min_zoom: minZoom, max_zoom: maxZoom}]): IFeature | IFeature[] => {
            const data = {seconds, maxZoom, minZoom}
            switch (name) {
              case "town":
                return new Point({id: LayerId.TOWN, get: getTowns, ...data})
              case "city":
                return new Point({id: LayerId.CITY, get: getCities, ...data})
              case "depth":
                return new Point({id: LayerId.DEPTH, get: getDepths, ...data})
              case "poi":
                return new FeaturePoi(data)
              case "buoy":
                return new Buoy(data)
              case "beacon":
                return new Beacon(data)
              case "line":
                return new Line(data)
              case "polygon":
                return new Polygon(data)
              case "other":
                return new Other(data)
              // case "bridge":
              //   return // @todo Добавить мосты
              default:
                return []
            }
          })
        )
      })
  }
}
